import { useQuery } from "@tanstack/react-query";
import { vocabService } from "../services/vocabService";

export const useAnalyzeTranslation = (sentence, userResponse) => {
  return useQuery({
    queryKey: ["analyzeTranslation", sentence, userResponse],
    queryFn: () => vocabService.analyzeTranslation(sentence, userResponse),
    enabled: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    select: (data) => ({
      analysisReport: data[0],
      analysisAudioLink: data[1],
    }),
  });
};
